import { OuraSymbolIcon } from '@jouzen/ecom-components';

import { EventType } from '@/analytics/types';
import { useHubspotFormsContext } from '@/app/[locale]/business/_contexts/HubspotFormsContext';
import LandingPageBlurb from '@/app/components/LandingPage/LandingPageBlurb';
import { BUSINESS_PATHNAME } from '@/app/consts/pathnames';

import { HUBSPOT_SELECTION_MODAL_ID } from '../HubspotSelectionModal';

const BusinessBringToWork = () => {
  const { setActiveModal } = useHubspotFormsContext();

  const handleClick = (): void => {
    setActiveModal(HUBSPOT_SELECTION_MODAL_ID);

    void window.ouraAnalytics.track(EventType.LinkClicked, {
      cta: 'get_in_touch',
      location: 'body',
      path: BUSINESS_PATHNAME,
    });
  };

  return (
    <section className="py-20" data-cy="business-bring-to-work">
      <LandingPageBlurb
        action={{
          dataCy: 'business-bring-to-work-action-button',
          title: 'business_bring_to_work_action',
          onClick: handleClick,
        }}
        description={{
          alignment: 'top',
          colStart: { lg: 16, xl: 14 },
          key: 'business_bring_to_work_description',
        }}
        title={{
          colEnd: { lg: 15, xl: 12, xxl: 11 },
          key: 'business_bring_to_work_title',
          multiline: false,
        }}
        iconTag={{
          icon: <OuraSymbolIcon />,
          iconTagText: 'business_bring_to_work_icon_tag',
        }}
      />
    </section>
  );
};

export default BusinessBringToWork;
